import React, { useState, useEffect, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import Switch from 'react-switch';

const EnableDisableButton = ({ checked, onChange }) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 480 });
  const toggleSize = isSmallScreen
    ? { height: 16, width: 36 }
    : { height: 20, width: 48 };

  return (
    <Switch
      onChange={onChange}
      checked={checked}
      uncheckedIcon={false}
      checkedIcon={false}
      offColor="#888"
      onColor="#6bd888"
      height={toggleSize.height}
      width={toggleSize.width}
      handleDiameter={toggleSize.handleDiameter}
    />
  );
};

EnableDisableButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

const ShareButton = ({ onClick, disabled }) => (
  <div style={{ flex: 1, textAlign: 'right' }}>
    <i
      className="fa fa-share-nodes fa-2x"
      aria-hidden="true"
      onClick={onClick}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        color: disabled ? 'grey' : 'primary',
      }}
    ></i>
  </div>
);

ShareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const MakeCopyButton = ({ onClick }) => (
  <div style={{ flex: 1 }}>
    <Button color="primary" size="sm" onClick={onClick}>
      Duplicate
    </Button>
  </div>
);

MakeCopyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const ThreeOptionToggle = ({ value, onChange, options, disabled }) => {
  const [switchPosition, setSwitchPosition] = useState(value);
  const [animation, setAnimation] = useState(null);

  // generate a unique name for each toggle instance
  const uniqueName = useRef(`triple-toggle-${Math.random().toString(36).substring(2, 9)}`).current;

  useEffect(() => {
    setSwitchPosition(value);
  }, [value]);

  const handleChange = (val) => {
    if (disabled) return;
    const prevIndex = options.findIndex(opt => opt.value === switchPosition);
    const newIndex = options.findIndex(opt => opt.value === val);
    let anim = null;

    if (prevIndex < newIndex) anim = `${switchPosition}-to-${val}`;
    else if (prevIndex > newIndex) anim = `${switchPosition}-to-${val}`;

    setSwitchPosition(val);
    setAnimation(anim);
    onChange(val);
  };

  const currentIndex = options.findIndex(opt => opt.value === switchPosition);

  return (
    <div
      style={{
        display: 'flex',
        backgroundColor: '#ddd',
        borderRadius: '20px',
        overflow: 'hidden',
        position: 'relative',
        height: '20px',
        width: '60px',
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      id = "three-option-toggle"
      title={disabled ? 'No edits allowed' : ''}
    >
      <div
        style={{
          position: 'absolute',
          width: '16px',
          height: '16px',
          backgroundColor: switchPosition === 'no_reply' ? '#e74c3c' : '#6bd888',
          borderRadius: '50%',
          transition: 'left 0.2s ease-in-out',
          top: '2px',
          left: `${currentIndex * 20 + 2}px`,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        title={disabled ? 'No edits allowed' : ''}
      />
      {options.map((option) => (
        <React.Fragment key={option.value}>
          <input
            type="radio"
            name={uniqueName}  // <== unique radio group per instance
            id={`${uniqueName}-${option.value}`}
            value={option.value}
            checked={switchPosition === option.value}
            onChange={() => handleChange(option.value)}
            style={{
              display: 'none',
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
            title={disabled ? 'No edits allowed' : ''}
          />
          <label
            htmlFor={`${uniqueName}-${option.value}`}
            style={{
              flex: 1,
              height: '100%',
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
            title={disabled ? 'No edits allowed' : ''}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

ThreeOptionToggle.propTypes = {
  value: PropTypes.string.isRequired, // currently selected value
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
};

// Export components
export { EnableDisableButton, ShareButton, MakeCopyButton, ThreeOptionToggle };
